<template>
  <div>
    <b-button @click="editUser" style="display: flex; flex-direction: row; align-items: center;">
      <i class='p-0 fa fa-pencil-square-o' style="margin-right: 8px;"></i>
      Editar
    </b-button>
  </div>
</template>

<script>
import EventBus from '../../../../Modules/EventBus';

export default {
  name: 'ActionsUser',
  props: ['data', 'index'],
  mounted: function () {
  },
  methods: {
    editUser: function () {
      EventBus.$emit('edit-user', this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/users-management/users-list/ActionsUser.vue